import { EnhancedFieldConfig } from '../../types/form/schema.types';
import { createShowWhenEqualsDependency } from './dependencies';

export interface CommentsTextareaOptions {
  name: string;
  label: string;
  disabled: boolean;
  decisionField?: string;
  showWhenValue?: unknown;
}

export const createCommentsTextarea = ({
  name,
  label,
  disabled,
  decisionField,
  showWhenValue = 'yes',
}: CommentsTextareaOptions): EnhancedFieldConfig => ({
  type: 'textArea',
  name,
  label,
  disabled,
  dependencies: decisionField
    ? [createShowWhenEqualsDependency(decisionField, showWhenValue)]
    : undefined,
});
